module.exports = __webpack_public_path__ + "img/regular_comm_fault_on.8fd75f57.svg";